import { Box, Button, Grid, Paper, TextField, Typography, Divider } from "@mui/material";
import {useNavigate, useLocation} from "react-router-dom";
import AuthLayout from "../layouts/AuthLayout/AuthLayout";
import { useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import ErrorDialog from "../../../components/ErrorDialog";
import { useAuthContext } from "../contexts/AuthContext";
import { googleLogin } from "../../../App";

function LoginPage() {
  let theme = useTheme();
  let navigate = useNavigate();
  let location = useLocation();
  let auth = useAuthContext();
  const [pageError, setPageError] = useState<string>("");

  let from = location.state?.from?.pathname || "/beacons";

  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    let formData = new FormData(event.currentTarget);
    let username = formData.get("username") as string;
    let password = formData.get("password") as string;

    auth.signin(username, password, (success: boolean, needsActivation: boolean, errorMessage: string) => {
      // Send them back to the page they tried to visit when they were
      // redirected to the login page. Use { replace: true } so we don't create
      // another entry in the history stack for the login page.  This means that
      // when they get to the protected page and click the back button, they
      // won't end up back on the login page, which is also really nice for the
      // user experience.
      if (needsActivation) {
        navigate('/activate');
      } else if (success) {
        navigate(from, { state: { username: username } });
        // navigate('/beacons');
      } else {
        setPageError(errorMessage);
      }
    });
  }

  useEffect(() => {
    // If the user is already logged in, send them on their way
    if (auth.user && auth.isBusinessUser() == true) {
      navigate(from, { replace: true });
    }
  },[auth.user, navigate, from]);

  function onCloseErrorDialog() {
      setPageError("");
  }

  return (
      <AuthLayout>
        <Box maxWidth="sm" mx="auto" mt={10} borderRadius={2} boxShadow={3}>
          <Box padding={4}>
            <Typography variant="h5" component="h2" align="center" mb={4} fontWeight="600">
              Log In
            </Typography>
            {location.state?.from && (
              <Typography align="center" mb={4} color="textSecondary">
                You must be logged in to view this page.
              </Typography>
            )}
            <form onSubmit={handleSubmit}>
              <Grid container gap={4}>
                <Grid item xs={12}>
                  <TextField name="username" label="Email" fullWidth variant="outlined" />
                </Grid>
                <Grid item xs={12}>
                  <TextField name="password" label="Password" fullWidth type="password" variant="outlined" />
                </Grid>
                <Grid item xs={12} textAlign="right">
                  <Button type="button" variant="text" onClick={() => navigate('/resetPassword')}>
                    Forgot password?
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Button type="submit" variant="contained" size="large" fullWidth>
                    Login
                  </Button>
                </Grid>
              </Grid>
            </form>
    
            <Box display="flex" alignItems="center" mt={4}>
              <Divider sx={{ flexGrow: 1 }} />
              <Typography variant="body2" mx={2}>or</Typography>
              <Divider sx={{ flexGrow: 1 }} />
            </Box>
    
            <Box display="flex" flexDirection="column" mt={2}>
              <Button variant="text" size="large" fullWidth onClick={() => navigate('/register')}>
                Sign Up
              </Button>
              <Button variant="text" size="large" fullWidth onClick={googleLogin}>
                Sign in with SSO
              </Button>
            </Box>
          </Box>
        </Box>
        <ErrorDialog errorMessage={pageError} open={pageError.length > 0} onClose={onCloseErrorDialog} />
      </AuthLayout>
    );
}

export default LoginPage;